var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgL1XIcon = function SvgL1XIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.458 25.578h2.662v-6.966h-2.662v6.966Zm7.224-11.458h6.896v-2.662h-6.896v2.662ZM0 14.12h7.035v-2.662H0v2.662ZM14.194 9.5a1.987 1.987 0 0 1-2.81 0L4.687 2.805 2.805 4.687 9.5 11.384a1.987 1.987 0 0 1 0 2.81L2.805 20.89l1.882 1.883 6.697-6.697a1.987 1.987 0 0 1 2.81 0l6.696 6.697 1.883-1.883-6.697-6.696a1.989 1.989 0 0 1 0-2.81l6.697-6.697-1.883-1.882L14.194 9.5Zm-2.736-2.537h2.662V0h-2.662v6.965Z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 13.228,
    y1: 0.322,
    x2: 13.228,
    y2: 25.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#890CE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#A824AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C2387F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D84959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E9563C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F55F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FC651B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6717"
  })))));
};
export default SvgL1XIcon;